module.exports = __webpack_public_path__ + "static/media/store-fairway.064c06a9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/views/whereToBuy/stores/store-fairway.jpg
// module id = 232
// module chunks = 0